import OneMood from '../../images/one_mood.png';
import TwoMood from '../../images/two_mood.png';
import ThreeMood from '../../images/three_mood.png';
import FourMood from '../../images/four_mood.png';
import FiveMood from '../../images/five_mood.png';
import { useDispatch, useSelector } from 'react-redux';
import styles from './Moods.module.scss';
import { setMoodForDate, setTodayMood } from '../../store/moodsSlice'
import { getLocalDateString } from '../../utils/date';
import { motion } from "motion/react"

export const moodIcons = [OneMood, TwoMood, ThreeMood, FourMood, FiveMood];

const Moods = ({ style, selectedMood, selectedDate }) => {
    const dispatch = useDispatch();
    const userId = useSelector(state => state.auth.user?.id);


    const isTodayDate = (date) => {
        const today = new Date();
        if (!date) return false; 
        return (
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear()
        );
    };


    const todayMood = useSelector(state => state.moods.todayMood?.mood);
    const selectedMoodValue = isTodayDate(selectedDate) ? todayMood : selectedMood;

    const handleClick = (index) => {
        if (!userId) return;

        const moodValue = index + 1;
        const dateStr = getLocalDateString(selectedDate);

        const isSameMoodSelected = selectedMoodValue === moodValue;

        if (isTodayDate(selectedDate)) {
            dispatch(setTodayMood({ userId, mood: isSameMoodSelected ? null : moodValue }));
        } else {
            dispatch(setMoodForDate({ userId, date: dateStr, mood: isSameMoodSelected ? null : moodValue }));
        }
    };


    return (
        <div className={`${styles.moods}`}>
            {/* {moodIcons.map((Icon, i) => (
                <motion.div
                    key={i}
                    className={`${styles.mood_wrapper} ${selectedMoodValue === i + 1 ? styles.selected : ''}`}
                    style={style}
                    onClick={() => handleClick(i)}
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                >
                    <Icon className={styles.mood_icon} title='Выбрать эмоцию' src={OneMood}/>
                </motion.div>
            ))} */}
            
            {moodIcons.map((iconSrc, i) => (
                <motion.div
                key={i}
                className={`${styles.mood_wrapper} ${selectedMood === i + 1 ? styles.selected : ''}`}
                style={{style}}
                onClick={() => handleClick(i)}
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.95 }}
                >
                <img
                    src={iconSrc}
                    alt={`mood ${i + 1}`}
                    title="Выбрать эмоцию"
                    className={styles.mood_icon}
                    loading="lazy"
                />
                </motion.div>
            ))}
        </div>
    );
};

export default Moods;